import React from 'react';
import {DivisionList} from "components/division/DivisionList";
import {Provider} from "components/division/DivisionContext";

export const Divisions = () => {

    return (
        <Provider>
            <DivisionList/>
        </Provider>
    );
}
